"use strict";

$(document).ready(function(){
	var crmType = custom.crm;

	// popup
	var popupSetting = custom.popup;
	if(popupSetting == 1){
		if(window.location.pathname == '/'){
			$('.popup__close, .popup__btn--text, .popup__content a.cta__btn').click(function(){
				$('body').removeClass('popup--active');
				$('body').addClass('popup--inactive');
				$('.popup').fadeOut(300, function(){
					$(this).remove();
				});
				$('.popup').addClass('popup--disable');
			});

			if(crmType == 'action-network'){
				$(document).on('web-popup_submitted', function(){
					$('body').removeClass('popup--active');
					$('body').addClass('popup--inactive');
					$('.popup').fadeOut(300, function(){
						$(this).remove();
					}); 
					$('.popup').addClass('popup--disable');
				});
			}
			if(crmType == 'actionkit'){
				$('.popup form').bind('ajax:complete', function(){
					$('body').removeClass('popup--active');
					$('body').addClass('popup--inactive');
					$('.popup').fadeOut(300, function(){
						$(this).remove();
					});
					$('.popup').addClass('popup--disable');
				});
			}
		}
	}

	// alert tray
	if($('#alert').hasClass('alert__type--contrib')){
		setTimeout(function(){
			$('.alert__type--contrib').slideDown(500);
		}, 1500);
	}

	// mobile nav
    $('.header__nav--mobile').click(function(){
        $('.hamburger').toggleClass('is-active');
        if($('.hamburger').hasClass('is-active')){
			// $('body').css({'position' : 'fixed'});
			$('.header__nav').css({'display' : 'flex'});
			$('.header__nav--wrap').addClass('is-active');
        } else{
			// $('body').css({'position' : 'relative'});
			$('.header__nav').css({'display' : 'none'});
			$('.header__nav--wrap').removeClass('is-active');
        }
    });

	// action network
	if(crmType == 'action-network'){
		if(window.location.pathname == '/'){
			// featured
			$(document).on('web-featured_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
				$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
			});

			// splash
			$(document).on('web-splash_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
				$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
			});
		}

		// media feed cta
		$(document).on('web-ad_loaded', function(){
			$('#can_embed_form_inner > h2').remove();
			$('#can_embed_form_inner > h3').remove();
			$('#can_embed_form_inner > h4').remove();
			$('li.form_builder_output').remove();
			$('input[name="subscription[sms_group]"]').prop('checked', true);
			$('#action_info').remove();
			$('#logo_wrap').remove();
			$('span.international_link-wrap').remove();
			$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
		});

		// footer cta
		$(document).on('web-footer-cta_loaded', function(){
			$('#can_embed_form_inner > h2').remove();
			$('#can_embed_form_inner > h3').remove();
			$('#can_embed_form_inner > h4').remove();
			$('input[name="subscription[sms_group]"]').prop('checked', true);
			$('#action_info').remove();
			$('#logo_wrap').remove();
			$('span.international_link-wrap').remove();
			$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
		});
	}

	// convert zip to latitude and longitude
	if(window.location.pathname == '/' ){
		$("#address").on('input', function(e){
			var zipcode = $("#address").val();
			if(zipcode){
				$.ajax({
					url: "https://maps.googleapis.com/maps/api/geocode/json",
					type: "GET",
					data: { address: zipcode, key: "AIzaSyAZQzPDSXx_IGi_UCtGAUT_3KpARfwEFaw" },
					dataType: "json",
					success: function(response){
						if(response.results && response.results.length > 0){
							var latitude = response.results[0].geometry.location.lat;
							var longitude = response.results[0].geometry.location.lng;
	
							console.log(latitude, longitude);
	
							$('input[name="lat"]').val(latitude);
							$('input[name="lon"]').val(longitude);
						} else {
							console.log('Invalid zip code.');
						}
					},
					error: function(error){
						 console.error("Error fetching location:", error);
					}
				});
			} else{
				console.log('Please enter a valid zip.');
			}
		});
	}

	// media filter
	$('[name="filter"]').change(function(){
		var url = $(this).val();
		window.location.href = url;
	});

	// recurring
	var yes = document.getElementById('monthly-yes');
	var no = document.getElementById('monthly-no');

	$('.cta__monthly--btn').click(function(){
		$('button.cta__monthly--btn.cta__monthly--btn-active').removeClass('cta__monthly--btn-active');
		$(this).addClass('cta__monthly--btn-active');
	});

	$(yes).click(function(){
		var urls = document.querySelectorAll('.footer-cta__contrib a.cta__btn');

		$(urls).each(function(i){
			var domains = urls[i].hostname;

			if(domains == 'secure.actblue.com' || domains == 'numero.ai' || domains == 'actionnetwork.org'){
				var oldUrl = urls[i].href;

				var searchParams = new URLSearchParams(oldUrl);
				var monthly = searchParams.get('recurring');

				if(monthly == 'false'){
					var newUrl = oldUrl.replace('&recurring=false', '&recurring=true');
				}
			}
			else if(domains == 'secure.ngpvan.com' || domains == 'secure.everyaction.com'){
				var oldUrl = urls[i].href;

				var searchParams = new URLSearchParams(oldUrl);
				var monthly = searchParams.get('r');

				if(monthly == 'false'){
					var newUrl = oldUrl.replace('&r=false', '&r=true');
				}
			}

			$(this).attr('href', newUrl);
		});
	});

	$(no).click(function(){
		var urls = document.querySelectorAll('.footer-cta__contrib a.cta__btn');

		$(urls).each(function(i){
			var domains = urls[i].hostname;

			if(domains == 'secure.actblue.com' || domains == 'numero.ai' || domains == 'actionnetwork.org'){
				var oldUrl = urls[i].href;

				var searchParams = new URLSearchParams(oldUrl);
				var monthly = searchParams.get('recurring');

				if(monthly == 'true'){
					var newUrl = oldUrl.replace('&recurring=true', '&recurring=false');
				}
			}
			else if(domains == 'secure.ngpvan.com' || domains == 'secure.everyaction.com'){
				var oldUrl = urls[i].href;

				var searchParams = new URLSearchParams(oldUrl);
				var monthly = searchParams.get('r');

				if(monthly == 'true'){
					var newUrl = oldUrl.replace('&r=true', '&r=false');
				}
			}

			$(this).attr('href', newUrl);
		});
	});
	
	// lity
	$('.wp-block-image img').attr('data-lity', '');
	$('.wp-block-timeline img').attr('data-lity', '');

	// aos
	AOS.init({
		easing: 'ease',
		duration: 1500
	});

	// anchors
	$(function(){
		$('a[href*="#"]:not([href="#"])').click(function(){
			if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname){
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length){
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000);
					return false;
				}
			}
		});
	});
});